/**
 * Created by jyothi on 22/8/17.
 */

/**
 * Server API root
 * @type {string}
 */
export const API_ROOT = process.env.NODE_ENV === "development" ? "https://localhost/host-redirect/v4/frontendapi/" : window.SERVER_ROOT;
export const API_BASE = process.env.NODE_ENV !== "production" ? "https://localhost/host-redirect/" : window.API_BASE;